<div class="hidden items-center justify-center text-xs md:flex xl:text-sm">
  @if ((loading$ | async) === false && this.currentIndex !== 0) {
    <button mat-icon-button color="primary" (click)="previous()">
      <mat-icon fontIcon="chevron_left"></mat-icon>
    </button>
  }

  <div
    class="relative mx-1 flex cursor-pointer items-center"
    (click)="openPartsModal()"
  >
    {{ partId }}
    @if (loading$ | async) {
      <fip-loading-spinner class="scale-75"></fip-loading-spinner>
    }
  </div>

  @if ((loading$ | async) === false) {
    <button mat-icon-button color="primary" (click)="next()">
      <mat-icon fontIcon="chevron_right"></mat-icon>
    </button>
  }
</div>
